export default __webpack_public_path__ + "static/media/1_0124.6a7cff91.webp";